import { useEffect } from "react";
import { Sports } from "../components/sections/Sports";
import { WorldMap } from "../components/sections/WorldMap";
import { MediaKit } from "../components/sections/MediaKit";
import { Sponsorship } from "../components/sections/Sponsorship";
import { Contact } from "../components/sections/Contact";

export default function SportsPage() {
  useEffect(() => {
    document.title = "Sports — REYCRO | Spartan · HYROX Race Journey";
  }, []);

  return (
    <div className="pt-16 md:pt-20">
      <Sports />
      <WorldMap />
      <MediaKit />
      <Sponsorship />
      <Contact />
    </div>
  );
}
